// Czech UI translations
export const cs = {
    // Common
    common: {
        save: "Uložit",
        cancel: "Zrušit",
        finish: "Dokončit",
        delete: "Smazat",
        edit: "Upravit",
        add: "Přidat",
        remove: "Odebrat",
        close: "Zavřít",
        apply: "Použít",
        search: "Hledat",
        filter: "Filtr",
        period: "Období",
        loading: "Načítání...",
        saving: "Ukládání...",
        error: "Chyba",
        success: "Úspěch",
        confirm: "Potvrdit",
        yes: "Ano",
        no: "Ne",
        ok: "OK",
        back: "Zpět",
        backToHome: "Zpět na hlavní stránku",
        next: "Další",
        previous: "Předchozí",
        select: "Vybrat",
        all: "Vše",
        none: "Žádné",
        settings: "Nastavení",
        options: "Možnosti",
        actions: "Akce",
        status: "Status",
        date: "Datum",
        amount: "Částka",
        companyName: "Název společnosti",
        currency: "Měna",
        description: "Popis",
        name: "Název",
        total: "Celkem",
        duplicate: "Duplikovat",
        shareLink: "Sdílet odkaz",
        selected: "vybráno",
        showing: "Zobrazeno",
        of: "z",
        noInvoicesFound: "Faktury nenalezeny",
        noExpensesFound: "Výdaje nenalezeny",
        tryChangingQuery: "Zkuste změnit vyhledávací dotaz",
        startByCreating: "",
        createFirstInvoice: "Vytvořit první fakturu",
        createFirstExpense: "Přidat první výdaj",
        language: "Jazyk",
        logout: "Odhlásit se",
        create: "Vytvořit",
        home: "Domů",
        optional: "Volitelné",
    },

    // Transfer Invoices
    transferInvoices: {
        title: "PŘENOS FAKTUR Z JINÉHO SYSTÉMU",
        menuLabel: "PŘENOS FAKTUR",
        description: "Rádi Vám pomůžeme přenést Vaše faktury z jakéhokoli jiného systému za poslední zdaňovací období. Uděláme to zdarma do 3 pracovních dnů (maximálně 50 faktur za 1 rok).",
        aiTransferTitle: "Pokud nechcete čekat, můžete zkusit přenést data ze svých faktur sami.",
        aiTransferDescription: "K tomu si zkopírujte pokyny pro svůj AI chat (doporučujeme ChatGPT) pomocí tlačítka {button} a přidejte zkopírovaný text ze svých faktur. Získanou odpověď vložte do formuláře níže a klikněte na tlačítko „Vytvořit faktury automaticky“.",
        setupRequired: "Chcete-li tak učinit, vyplňte formulář níže:",
        prefilledText: "Dobrý den, chtěl/a bych přenést následující faktury:",
        storageLink: "Odkaz na úložiště souborů (např. Google Drive)",
        storageLinkPlaceholder: "Ujistěte se, že odkaz je přístupný všem uživatelům",
        emailNote: "Pokud chcete poslat soubory e-mailem, napište nám na {email}",
        submit: "Odeslat žádost",
        manualSubmitButton: "Odeslat ruční žádost",
        autoSubmitButton: "Vytvořit faktury automaticky",
        jsonDataLabel: "Data pro automatické vytvoření (formát JSON)",
        jsonDataPlaceholder: "Sem vložte svůj JSON pro automatické zpracování...",
        jsonDataHelp: "Pokud máte data v našem formátu JSON, můžete je sem vložit pro automatické vytvoření faktur.",
        success: "Žádost byla odeslána! Budeme Vás brzy kontaktovat.",
        autoSuccess: "{count} faktur bylo vytvořeno automaticky!",
        specificationButton: "Specifikace",
        copyLlmButton: "Instrukce pro LLM",
        llmInstructionsTitle: "Instrukce zkopírována!",
        llmInstructionsDescription: "Nyní můžete tento prompt vložit do své LLM (ChatGPT, Claude atd.) pro převod dat.",
        specificationTitle: "Specifikace JSON",
    },
    expenses: {
        title: "Výdaje",
        addExpense: "Přidat výdaj",
        editExpense: "Upravit výdaj",
        expenseName: "Název / Dodavatel",
        category: "Kategorie",
        date: "Datum",
        amount: "Částka",
        currency: "Měna",
        note: "Poznámka",
        manageTitle: "Správa výdajů",
        deleteConfirm: "Opravdu chcete tento výdaj smazat?",
        validationMessage: "Zadejte název a částku",
        categories: {
            subscriptions: "Předplatné a služby",
            consulting: "Konzultace",
            communication: "Komunikace",
            education: "Vzdělávání",
            equipment: "Vybavení",
            marketing: "Reklama / Marketing",
            rent: "Kancelář / Pronájem",
            software: "Software / SaaS",
            supplies: "Spotřební materiál",
            travel: "Cestování",
            salary: "Mzdy",
            taxes: "Daně",
            other: "Ostatní"
        }
    },
    // Support
    support: {
        miniLabel: "Chybí Vám nějaká funkce? Něco nefunguje? Máte otázky?",
        button: "PODPORA",
        modalTitle: "Technická podpora",
        modalSubtitle: "Pracujeme 7 dní v týdnu.",
        modalEmailLabel: "Napište na e-mail",
        modalNote: "Napište z e-mailu, na který jste zaregistrovali svůj účet.",
    },

    // Invoice App
    invoice: {
        invoiceGenerator: "Generátor faktur",
        invoiceBasics: "Základní údaje",
        parties: "Strany",
        subtotal: "Mezisoučet",
        grandTotal: "Celkem",
        save: "Uložit",
        saving: "Ukládání...",
        saved: "Uloženo",
        notSaved: "Neuloženo",
        invoiceNumber: "Číslo faktury",
        issueDate: "Datum vystavení",
        dueDate: "Datum splatnosti",
        customer: "Zákazník",
        address: "Adresa",
        buyerId: "ID kupujícího",
        loadDefaults: "Nastavit výchozí údaje",
        sellerInfo: "Informace o prodávajícím",
        country: "Země",
        notes: "Poznámky",
        identificationNumber: "IČO",
        dic: "DIČ",
        czechSoleProprietor: "Mám Živnostenský list v ČR",
        czechSoleProprietorTooltip: "Přidá povinné právní informace na fakturu",
        paymentInfo: "Platební informace",
        items: "Položky",
        addItem: "Přidat položku",
        pricePerUnit: "Cena za jednotku",
        note: "Poznámka",
        downloadPdf: "Stáhnout PDF",
        print: "Tisk (dialog)",
        sendByEmail: "Odeslat e-mailem",
        saveInvoiceFirst: "Nejdříve fakturu uložte",
        newInvoice: "Nová faktura",
        invoiceNumberRequired: "Zadejte číslo faktury pro uložení nebo stažení",
        invoiceNumberEmpty: "Číslo faktury je povinné",
        comingInFebruary: "Bude k dispozici v únoru, těšte se na aktualizace!",
        printNote: "Při tisku přes dialog odškrtněte 'Hlavičky'. Tlačítko 'Stáhnout PDF' automaticky odstraní vše zbytečné.",
        daysUntilDue: "Dní do splatnosti",
        dueDateSettings: "Nastavení data splatnosti",
        dueDateExplanation: "Nastavte výchozí počet dní pro datum splatnosti platby. Toto bude aplikováno na nové faktury.",
        invoiceLanguage: "Jazyk faktury",
        invoiceNumberTemplate: "Šablona čísla faktury",
        invoiceNumberTemplateTooltip: "Nastavení šablony čísla faktury",
        paymentOptions: "Možnosti platby",
        addPaymentOption: "Přidat možnost platby",
        paymentType: "Typ platby",
        paymentTitle: "Název",
        paymentDetails: "Detaily",
        bankTransfer: "Bankovní převod",
        onlinePayment: "Online platba",
        cash: "Hotovost",
        custom: "Vlastní",
        paymentUponDelivery: "Platba při dodání nebo vyzvednutí",
        enterCustomPaymentDetails: "Zadejte vlastní platební údaje",
        paymentMethodBankingDetails: "Způsob platby a bankovní údaje",
        removePaymentOption: "Odebrat",
        businessLogo: "Logo firmy",
        uploadLogo: "Nahrát logo",
        removeLogo: "Odebrat logo",
        website: "Webová stránka",
        websiteText: "Text webové stránky",
        issuedBy: "Vystavil",
        acceptedBy: "Přijal",
        signature: "Podpis",
        uploadSignature: "Nahrát podpis",
        removeSignature: "Odebrat podpis",
        vatPayer: "Plátce DPH?",
        nonVatPayer: "Neplátce DPH",
        notSpecified: "Neuvedeno",
        taxSettings: "Nastavení daní",
        enableVat: "Zapnout DPH",
        vatRate: "Sazba DPH (%)",
        vat: "DPH",
        netAmount: "Částka bez DPH",
        vatAmount: "Částka DPH",
        totalAmount: "Celková částka",
        discount: "Sleva",
        quantity: "Množství",
        price: "Cena",
        unit: "Jednotka",
        discountPercent: "Sleva (%)",
        applyDiscount: "Použít slevu",
        itemDiscount: "Sleva na položku",
        totalDiscount: "Celková sleva",
        addCustomTax: "Přidat daň",
        taxName: "Název daně",
        taxAmount: "Částka daně",
        taxPercentage: "Procento daně",
        fixedAmount: "Pevná částka",
        percentage: "Procento",
        czechMarket: "Pro český trh",
        internationalMarket: "Pro mezinárodní trh",
        accountNumber: "Číslo účtu",
        bankName: "Název banky",
        bankAddress: "Adresa banky",
        variableSymbol: "Variabilní symbol",
        constantSymbol: "Konstantní symbol",
        specificSymbol: "Specifický symbol",
        paymentLink: "Platební odkaz",
        paymentUrl: "URL platby",
        linkText: "Text odkazu",
        account: "Účet",
        bank: "Banka",
        showQRCode: "Zobrazit QR kód (platí pouze pro české banky!)",
        invoiceStatus: "Status faktury",
        status: "Status",
        managePaymentMethods: "Spravovat platební metody",
        manageClients: "Spravovat uložené klienty",
        manageSavedItems: "Spravovat uložené položky",
        templateButton: "Šablona",
        manageButton: "Spravovat",
        savedPaymentMethods: "Uložené platební metody",
        selectPaymentMethod: "Vybrat platební metodu",
        addSaved: "Přidat uložené",
        descriptionPlaceholder: "Popis služby / produktu",
        unitPlaceholder: "ks",
        units: {
            pcs: "ks",
            hours: "hod",
            days: "dny",
            months: "měs",
            kg: "kg",
            unit: "jedn",
            liters: "litry",
            m: "m",
            m2: "m²",
            m3: "m³",
        },
        noSavedMethods: "Nebyly nalezeny žádné uložené platební metody",
        selectSavedPaymentMethod: "Vybrat uloženou platební metodu",
        useExistingPaymentInfo: "Použijte existující platební informace k automatickému vytvoření platebních možností nebo je přidejte ručně.",
        autoPopulate: "Automaticky vyplnit z existujících dat",
        saveAsTemplate: "Uložit tuto konfiguraci jako šablonu",
        onboarding: {
            startTitle: "Jak vystavovat faktury v Invoitio? Naučte se za 2 minuty.",
            startButton: "Začít školení",
            skipButton: "Přeskočit",
            tutorialButton: "Školení",
            trainingLocation: "Školení je vždy zde. Pokud nebudete vědět, jak něco udělat, aktivujte jej na libovolné stránce!",
            steps: {
                basics: {
                    title: "Základní údaje",
                    description: "Zde si můžete vybrat jazyk, a datum splatnosti faktury a také změnit její číslo.",
                },
                template: {
                    title: "Šablony",
                    description: "Kliknutím sem nakonfigurujete šablonu automatického číslování Vašich faktur.",
                },
                dueDate: {
                    title: "Datum splatnosti",
                    description: "Lhůtu splatnosti můžete nastavit pomocí pole s datem nebo počtem dnů kliknutím na tlačítko nastavení.",
                },
                parties: {
                    title: "Strany",
                    description: "Vyplňte údaje prodávajícího a klienta. Mezi nimi můžete přepínat pomocí záložek.",
                },
                manageClients: {
                    title: "Správa klientů",
                    description: "Zde si uložte údaje o klientech, abyste je v budoucnu vybrali jedním kliknutím.",
                },
                items: {
                    title: "Položky",
                    description: "Přidejte služby nebo produkty. Mezisoučet a daně budou vypočteny automaticky.",
                },
                payment: {
                    title: "Platební metody",
                    description: "Vyberte platební metody. Můžete si je uložit jako šablony pro rychlé vložení.",
                },
                status: {
                    title: "Stav platby",
                    description: "Sledujte životní cyklus platby. Stav „Po splatnosti“ se automaticky aktualizuje u faktur ve stavu „Čeká na zaplacení“, pokud nejsou označeny jako zaplacené. V menu v „Upozornění pro klienty“ můžete také nastavit automatické upozorňování zákazníků.",
                },
                save: {
                    title: "Uložit fakturu",
                    description: "Pokud chcete uložit údaje ve faktuře, nezapomeňte kliknout na tlačítko Uložit!",
                },
                final: {
                    title: "Nejdůležitější!",
                    description: "Aby Vaše faktura splňovala formální požadavky v České republice, vyplňte VŠECHNA pole týkající se právních informací v sekcích: Klient, Informace o prodejci, alespoň 1 platební metodu a alespoň jednu položku nebo službu.",
                    button: "Rozumím!"
                }
            }
        },
        validation: {
            modalTitle: "Neúplná faktura",
            modalMessage: "Ve faktuře nejsou vyplněna povinná pole: {fields}. Opravdu chcete fakturu takto uložit?",
            modalMessageDownload: "Ve faktuře nejsou vyplněna povinná pole: {fields}. Opravdu chcete fakturu stáhnout?",
            fixButton: "Opravit",
            continueButton: "Pokračovat",
            downloadButton: "Stáhnout",
            okButton: "Uložit",
            errorRequired: "Toto pole je povinné",
            errorRequiredWarning: "Vyplňte, pokud klient není fyzická osoba, jinak to není povinné pole",
            sectionError: "Prosím vyplňte povinná pole v této sekci",
            aresButton: "Automaticky doplnit všechny údaje firmy z ČR",
            aresLoading: "Načítání...",
            aresNotFound: "Firma nebyla nalezena",
            aresError: "Chyba při načítání dat",
            aresMinChars: "Zadejte alespoň 8 znaků",
            fields: {
                invoiceNo: "Číslo faktury",
                issueDate: "Datum vystavení",
                dueDate: "Datum splatnosti",
                sellerName: "Název prodejce",
                sellerTaxId: "IČO prodejce",
                sellerVatNumber: "DIČ prodejce",
                sellerAddress: "Adresa prodejce",
                buyerName: "Název klienta",
                buyerTaxId: "IČO klienta",
                buyerVatNumber: "DIČ klienta",
                buyerAddress: "Adresa klienta",
                buyerEmail: "E-mail klienta",
                sellerEmail: "E-mail prodejce",
                items: "Položky (přidejte alespoň jednu)",
                itemsValid: "Popis a cena u každé položky",
                paymentOptions: "Platební metoda (vyberte alespoň jednu)",
                paymentBank: "Bankovní údaje (číslo účtu nebo IBAN)",
                paymentLink: "Platební odkaz",
                paymentCustom: "Popis platební metody",
            }
        },
    },

    // Invoice List
    invoiceList: {
        title: "Seznam faktur",
        newInvoice: "Nová faktura",
        searchPlaceholder: "Hledat faktury...",
        noInvoices: "Faktury nenalezeny",
        columns: {
            invoiceNumber: "Číslo",
            client: "Klient",
            description: "Popis",
            amount: "Částka",
            issueDate: "Datum vystavení",
            dueDate: "Datum splatnosti",
            status: "Status",
            actions: "Akce",
        },
        invoiceStatus: "Stav úhrady faktury:",
        status: {
            paid: "Zaplaceno",
            pending: "Čeká na zaplacení",
            overdue: "Po splatnosti",
        },
        actions: {
            edit: "Upravit",
            delete: "Smazat",
            download: "Stáhnout",
            downloadPdf: "Stáhnout PDF",
            archive: "Archivovat",
            changeStatus: "Změnit status",
        },
        deleteModal: {
            title: "Smazat fakturu",
            message: "Opravdu chcete smazat tuto fakturu? Tato akce je nevratná.",
            messageMultiple: "Opravdu chcete smazat {count} vybraných faktur? Tato akce je nevratná.",
            confirm: "Smazat",
            cancel: "Zrušit",
        },
        settings: {
            title: "Výchozí nastavení faktur",
            configureMyData: "NASTAVIT MOJE ÚDAJE PRO FAKTURY",
            sellerModalTitle: "Výchozí údaje dodavatele",
            sellerName: "Název",
            sellerTaxId: "IČO",
            sellerVatNumber: "DIČ",
            sellerWebsite: "Webové stránky",
            sellerAddress: "Adresa",
            sellerIsCzechSoleProprietor: "Mám Živnostenský list v ČR",
            sellerIsVatPayer: "Plátce DPH",
            sellerNotes: "Poznámky",
            vatNotSpecified: "Neuvedeno",
            vatPayer: "Plátce",
            vatNotPayer: "Neplátce",
            defaultDueDays: "Výchozí dny do splatnosti",
            defaultDueDaysDescription: "Počet dní do data splatnosti platby",
            defaultTemplate: "Výchozí šablona",
            invoiceStyle: "Styl faktury",
            defaultCurrency: "Výchozí měna",
            defaultLanguage: "Výchozí jazyk",
            invoiceNumberTemplate: "Šablona čísla faktury",
            save: "Uložit",
            cancel: "Zrušit",
            saved: "Nastavení bylo úspěšně uloženo",
            saving: "Ukládání...",
        },
        onboarding: {
            startTitle: "Naučte se spravovat a nastavovat faktury za 2 minuty",
            startButton: "Spustit výuku",
            skipButton: "Přeskočit",
            trainingLocation: "Školení je vždy zde. Pokud nebudete vědět, jak něco udělat, aktivujte ji na jakékoli stránce!",
            tutorialButton: "ŠKOLENÍ",
            steps: {
                table: {
                    title: "Tabulka faktur",
                    description: "Zde je tabulka, ve které se zobrazují všechny Vaše vytvořené faktury.",
                },
                actions: {
                    title: "Akce s fakturou",
                    description: "V tomto sloupci můžete stáhnout fakturu, sdílet zabezpečený odkaz, poslat upomínku e-mailem, duplikovat nebo smazat fakturu.",
                },
                bulk: {
                    title: "Hromadné akce",
                    description: "Výběrem více faktur je můžete hromadně duplikovat, smazat, stáhnout jako archiv nebo exportovat do Excelu.",
                },
                settings: {
                    title: "Výchozí nastavení",
                    description: "Toto je velmi důležitá sekce! Zde se nastavují údaje, které se budou automaticky vyplňovat do všech nových faktur: jazyk, informace o prodejci, měna a šablona čísla faktury.",
                },
                filters: {
                    title: "Filtry",
                    description: "Pomocí filtrů můžete rychle najít potřebné faktury nebo změnit způsob jejich zobrazení v seznamu.",
                },
                newInvoice: {
                    title: "Vytvořit fakturu",
                    description: "Chcete-li vytvořit novou fakturu, stačí kliknout na toto tlačítko!",
                }
            }
        },
        archive: {
            download: "Stáhnout archiv",
            downloading: "Stahování...",
            archiving: "Archivujeme faktury",
            noSelection: "Vyberte faktury k archivaci",
        },
        errors: {
            statusChangeError: "Chyba při změně statusu",
            deleteError: "Chyba při mazání faktury",
            backendDeleteError: "Chyba při mazání faktury z backendu",
            archiveError: "Chyba při vytváření archivu",
            backendNotAvailable: "Backend není dostupný. Stažen textový soubor místo ZIP archivu.",
        },
        filter: "Filtr",
        filterSortBy: "Řadit podle",
        filterSortOrder: "Pořadí řazení",
        filterIssueDate: "Datum vystavení",
        filterAmount: "Částka",
        filterDueDate: "Datum splatnosti",
        filterClientName: "Jméno klienta",
        filterCreatedAt: "Datum vytvoření",
        filterStatus: "Stav",
        filterStatusSort: "Podle stavu",
        filterAscending: "Vzestupně",
        filterDescending: "Sestupně",
        filterSelectField: "Vyberte pole",
        filterSelectOrder: "Vyberte pořadí",
        filterReset: "Resetovat",
    },

    // Statistics
    statistics: {
        title: "Statistiky",
        totalRevenue: "Celkový příjem",
        revenueByClient: "Příjem podle klientů",
        revenueByCurrency: "Příjem podle měn",
        revenueTimeline: "Časová osa příjmu",
        baseCurrency: "Základní měna",
        selectYear: "Vybrat rok",
        allYears: "Všechny roky",
        year: "Rok",
        month: "Měsíc",
        client: "Klient",
        revenue: "Příjem",
        income: "Příjem",
        expense: "Výdaj",
        totalExpenses: "Celkové výdaje",
        expensesByCategory: "Výdaje podle kategorií",
        expensesByCurrency: "Výdaje podle měn",
        percentage: "Procento",
        info: "Info",
        infoTooltip: "Směnné kurzy jsou načítány z Evropské centrální banky (ECB) a jsou aktualizovány v reálném čase pro podporované měny EU a další měny.\n\nV reálném čase jsou aktualizovány následující měny:\nEUR, USD, CZK, GBP, ARS, AUD, BGN, BRL, CAD, CHF, CNY, DKK, HKD, HRK, HUF, IDR, ILS, INR, ISK, JPY, KRW, MAD, MXN, MYR, NOK, NZD, PHP, PLN, RON, RUB, SEK, SGD, THB, TRY, TWD, ZAR.\n\nOstatní měny jsou aktualizovány jednou měsíčně. Pro jejich převod se používá švýcarský frank (CHF) jako meziměna.\n\nCHF se také používá jako meziměna při výpočtu celkového příjmu pro všechny měny kromě CZK, EUR, USD a GBP, které jsou převáděny v reálném čase podle kurzů ECB.",
        loadingRates: "Načítání směnných kurzů...",
        noData: "Žádná data",
        arpu: {
            label: "Průměrný příjem na uživatele (ARPU)",
            period: "Období",
            formula: "Celkový příjem ÷ Platící klienti",
            formulaLabel: "Vzorec ARPU:",
            formulaFull: "ARPU = Celkový příjem ÷ Platící klienti (zde na klienta)",
        },
        mrr: {
            label: "Měsíční opakující se příjem (MRR)",
            formula: "Platící klienti × ARPU",
            formulaLabel: "Vzorec MRR:",
            formulaFull: "MRR = (Celkový počet platících klientů) × (Průměrný příjem na uživatele)",
        },
        netIncome: "Čistý zisk (příjmy - výdaje)",
        avgMonthlyRevenue: "Průměrný měsíční příjem",
        avgMonthlyExpenses: "Průměrný měsíční výdaj",
        includePending: "Zahrnout faktury čekající na platbu do výpočtů?",
        statusDistribution: "Rozdělení stavů faktur",
        period: "Období",
        total: "Celkem",
        allTime: "Za celou dobu",
        currentMonth: "Tento měsíc",
        previousMonth: "Minulý měsíc",
        previousYear: "Minulý rok",
        exportToExcel: "Export do Excelu",
        exportModal: {
            title: "Export do Excelu",
            selectRange: "Vyberte časové období",
            from: "Od",
            to: "Do",
            tableLanguage: "Jazyk tabulky",
            download: "Stáhnout"
        },
    },

    // Invoice Templates
    invoiceTemplates: {
        title: "Šablony faktur",
        comingSoon: "Již brzy",
        description: "Vytvářejte a spravujte své vlastní šablony faktur, abyste urychlili svůj pracovní postup.",
        createTemplate: "Vytvořit šablonu",
    },

    // Repeating Invoices
    repeatingInvoices: {
        title: "Opakované faktury",
        step1: "Krok 1 - vyberte fakturu pro opakování",
        step2: "Krok 2 - vyberte interval",
        everyMonthDay: "Chci vystavovat každý",
        dayOfMonth: "den v měsíci",
        lastDayNote: "* Pokud má měsíc méně dní, bude použit poslední den v měsíci",
        or: "— NEBO —",
        intervalLabel: "Chci vystavovat fakturu každých",
        days: "dní",
        fromDate: "Od",
        toDate: "Do",
        templateNameLabel: "Název šablony",
        templateNamePlaceholder: "např. Měsíční faktura pro E-Corp s.r.o.",
        optional: "(nepovinné)",
        createButton: "Vytvořit opakované faktury",
        managementTitle: "Správa opakovaných faktur",
        noTemplates: "Zatím nemáte žádné šablony opakovaných faktur.",
        noTemplatesSub: "Vyberte fakturu a nakonfigurujte nastavení opakování výše pro vytvoření Vaší první šablony.",
        deleteConfirm: "Opravdu chcete smazat tuto šablonu opakovaných faktur?",
        successCreated: "Hotovo! Úspěšně jste vytvořili {count} faktur",
    },

    // Client Notifications
    clientNotifications: {
        title: "Upozornění pro klienty",
        setupNotice: "Předtím, než začnete používat upozornění, proveďte nastavení:",
        setupAlwaysChange: "Toto můžete kdykoli změnit v Obecná nastavení -> E-mailová adresa pro upozornění klientům",
        setupRequiredTitle: "Nutné nastavení",
        setupRequiredDescription: "Prosím, vyplňte a uložte jméno odesílatele a e-mailový handle výše, abyste odblokovali sekce s připomínkami.",
        manualSection: "Ruční odesílání připomínek",
        manualStep1: "Krok 1 - Vyberte šablonu e-mailu",
        manualStep2: "Krok 2 - Vyberte fakturu k odeslání",
        emailLangLabel: "Jazyk e-mailu",
        manualEditNotice: "Budete mít možnost upravit e-mail před odesláním v kroku 'Náhled a odeslání'",
        autoEditNotice: "Budete mít možnost upravit e-mail před odesláním v kroku 'Náhled a nastavení upomínky' níže.",
        previewAndSend: "Náhled a odeslání",
        allInvoices: "Všechny faktury",
        overdueInvoicesOnly: "Faktury po splatnosti",
        overdueInvoices: "Faktury po splatnosti",
        reminderSent: "Připomínka byla úspěšně odeslána!",
        reminderError: "Nepodařilo se odeslat připomínku. Zkontrolujte prosím nastavení nebo e-mailovou adresu klienta.",
        noEmailError: "Tento klient nemá zadanou e-mailovou adresu.",
        noInvoicesFound: "Nebyly nalezeny žádné faktury.",
        howItWorksTitle: "JAK TO FUNGUJE?",
        howItWorksDescription: "Automatické připomínky se nastavují globálně pro konkrétního uloženého klienta. Aby fungovaly, ujistěte se, že při vytváření nových faktur vybíráte klienta ze seznamu uložených prostřednictvím pole „Vyberte klienta“ a {clientLink} na {appLink}. Pokud chcete poslat připomínku pouze pro jednu konkrétní fakturu, použijte sekci {manualLink} výše.",
        clientLink: "„Spravovat uložené klienty“",
        appLink: "stránce vytvoření nových faktur",
        manualLink: "„Ruční odesílání“",
        autoSection: "Nastavení automatických připomínek",
        autoStep1: "Krok 1 - Vyberte klienta",
        autoStep2: "Krok 2 - Konfigurace",
        autoIntervalLabel: "Chci odesílat automatické připomínky klientovi",
        autoIntervalShort: "Odeslat po",
        daysAfterDue: "dní po splatnosti",
        emailTemplateLabel: "Šablona e-mailu, kterou chci použít:",
        emailTemplateShort: "Šablona",
        standardTemplateChoice: "Vyberu standardní šablonu v",
        saveSettings: "Náhled a nastavení upomínky",
        sendManual: "Odeslat připomínku",
        confirmModalTitle: "Takto bude vypadat e-mail pro klienta:",
        recipientEmailLabel: "E-mail klienta:",
        sendTo: "odeslat na",
        editEmail: "Upravit e-mail",
        save: "Uložit",
        invoiceDownloaded: "Faktura byla stažena, můžete si ji prohlédnout",
        missingFieldsTitle: "Ve faktuře nebo e-mailu chybí následující údaje:",
        missingFieldsNote: "Změňte samotnou {invoiceLink} a text níže kliknutím на tlačítko 'Upravit e-mail'",
        invoiceLink: "fakturu",
        emailNotConfiguredTitle: "E-mail pro odesílání není nastaven",
        emailNotConfiguredDescription: "Musíte přejít do sekce {link} a nastavit svou e-mailovou adresu, abyste mohli odesílat oznámení.",
        notificationsLink: "Oznámení klientům",
        emailMissingTitle: "Chybí e-mailová adresa",
        emailMissingDescription: "Tento klient nemá zadanou e-mailovou adresu. Před nastavením automatických připomínek ji musíte přidat v 'Správa uložených klientů'.",
        noOverdue: "Žádné faktury po splatnosti nenalezeny.",
        noInvoicesTitle: "Zatím nemáte žádné faktury",
        noInvoicesDescription: "Vytvořte svou první fakturu, abyste mohli začít používat systém připomínek pro své klienty.",
        createFirstInvoice: "Vytvořit první fakturu",
        previewInstructionAuto: "Chcete-li vidět, jak bude vypadat odeslaný e-mail, vytvořte svou první fakturu a vyberte ji v této sekci pro náhled!",
        previewInstructionManual: "Pro náhled vyberte fakturu kliknutím na řádek v kroku 2",
        noClients: "Žádní klienti nenalezeni.",
        searchInvoices: "Hledat faktury po splatnosti...",
        searchClients: "Hledat klienty...",
        placeholderCompany: "Název Vaší společnosti",
        placeholderPayment: "{paymentDetails}",
        customTemplateChoice: "Vlastní text",
        manageAutoSection: "Správa automatických upomínek",
        reminderFor: "Upomínka pro",
        lastSent: "Naposledy odesláno",
        neverSent: "Nikdy",
        activeStatus: "Aktivní",
        inactiveStatus: "Pozastaveno",
        noAutoReminders: "Nejsou nastaveny žádné automatické upomínky.",
        deleteReminderConfirm: "Opravdu chcete zrušit automatické upomínky pro tohoto klienta?",
        actions: {
            sendReminder: "Odeslat upomínku"
        }
    },

    // Client Dialog
    clientDialog: {
        title: "Klient",
        manageTitle: "Spravovat klienty",
        addTitle: "Přidat nového klienta",
        editTitle: "Upravit klienta",
        name: "Název",
        address: "Adresa",
        email: "Email",
        phone: "Telefon",
        taxId: "Daňové ID",
        buyerId: "ID kupujícího",
        namePlaceholder: "Název klienta",
        addressPlaceholder: "Adresa klienta",
        buyerIdPlaceholder: "ID: 12345678",
        selectClient: "Vyberte klienta",
        existingClients: "Existující klienti",
        noClients: "Zatím nejsou přidáni žádní klienti.",
        add: "Přidat klienta",
        update: "Aktualizovat klienta",
        save: "Uložit",
        cancel: "Zrušit",
        delete: "Smazat",
        deleteConfirm: "Opravdu chcete smazat tohoto klienta?",
        validationMessage: "Alespoň jedno pole musí být vyplněno",
    },

    // Payment Method Dialog
    paymentMethodDialog: {
        title: "Způsob platby",
        manageTitle: "Spravovat platební metody",
        addTitle: "Přidat platební metodu",
        editTitle: "Upravit platební metodu",
        type: "Typ",
        titleLabel: "Název",
        details: "Detaily",
        accountNumber: "Číslo účtu",
        iban: "IBAN",
        bicSwift: "BIC/SWIFT",
        bankName: "Název banky",
        bankAddress: "Adresa banky",
        variableSymbol: "Variabilní symbol",
        constantSymbol: "Konstantní symbol",
        specificSymbol: "Specifický symbol",
        paymentUrl: "URL platby",
        linkText: "Text odkazu",
        savedMethods: "Uložené platební metody",
        noMethods: "Zatím nejsou uloženy žádné platební metody.",
        add: "Přidat platební metodu",
        update: "Aktualizovat platební metodu",
        save: "Uložit",
        cancel: "Zrušit",
        delete: "Smazat",
        deleteConfirm: "Opravdu chcete smazat tuto platební metodu?",
        validationMessage: "Název a alespoň jedno další pole musí být vyplněno",
        bankTransfer: "Bankovní převod",
        paymentLink: "Platební odkaz",
        cash: "Hotovost",
        custom: "Vlastní",
        titlePlaceholderBank: "Bankovní převod",
        titlePlaceholderLink: "Platba online",
        titlePlaceholderCash: "Hotovost",
        titlePlaceholderCustom: "Vlastní platba",
        detailsPlaceholderCash: "Platba hotovostí při dodání nebo vyzvednutí",
        detailsPlaceholderCustom: "Zadejte detaily platby",
    },

    // Landing Page
    landing: {
        hero: {
            title: "Rychlá aplikace na faktury.\n Na počítači i mobilu.",
            subtitle: "Odesílání faktury e-mailem i do messengerů přímo z aplikace, evidence výdajů a zisku, platba pomocí QR kódu. Nejpohodlnější fakturační služba pro freelancery, startupy a malé firmy v České republice a Evropské unii.",
            tryButton: "Vyzkoušejte zdarma na 30 dní",
            noCardRequired: "💳🚫 Bez platební karty",
            madeInCzech: "Vyrobeno v České republice",
            womenOwned: "Women-owned",
        },
        nav: {
            tryIt: "Registrovat a stáhnout vzor faktury",
            functionality: "Funkce",
            pricing: "Ceník",
            faq: "Časté dotazy",
            invoiceList: "Blog",
            login: "Přihlásit se",
            start: "Začít zdarma",
            contact: "Kontakt",
        },
        features: {
            title: "Funkce",
            voiceInput: "1 věta místo nekonečných formulářů",
            voiceInputDescription: "Mluvíte — Invoitio počítá a vystaví fakturu. Rychle a bez chyb.",
            reports: "Zprávy o zisku",
            reportsDescription: "Přehledné grafy místo ručních výpočtů — ušetřete čas svého účetního.",
            reminders: "Připomínky o po splatnosti",
            remindersDescription: "Klient nezaplatil včas? Invoitio Vám připomene — zdvořile a včas.",
            mobile: "Podpora mobilních zařízení",
            mobileDescription: "Rozhraní funguje na jakémkoli zařízení.",
            storage: "Spolehlivé úložiště",
            storageDescription: "Všechny faktury na jednom místě, s rychlým vyhledáváním.",
            languages: "Podpora 5 jazyků",
            languagesDescription: "Angličtina, čeština, slovenština, němčina a ruština. Plus přizpůsobení polí.",
            modern: {
                unlimited: "Bez omezení počtu faktur a uživatelů",
                analytics: "Jeden jasný přehled zisku a výdajů s metrikami",
                repeating: "Pravidelné faktury - vytvořte je jedním kliknutím pro stálé klienty",
                send: "Odesílání faktur e-mailem a přes messengery",
                multi: "Libovolná měna, 5 jazyků rozhraní i faktur, QR platba",
                notSure: "Ještě si nejste jisti?",
                fullList: "Kompletní seznam funkcí",
                roadmapTitle: "Plánované funkce",
            },
            grid: {
                transfer: "Zdarma převedeme Vaše faktury za poslední rok. I během zkušebního období!",
                security: "Vaše data jsou v bezpečí. Pro ochranu Vašich dat při přenosu i ukládání používáme šifrování.",
                eu_servers: "🇪🇺 Servery pouze v Evropské unii",
                charts: "Přehledný graf příjmů a výdajů",
                messengers: "Odesílání faktur do messengerů – WhatsApp, Telegram a jakékoli další messengery přímo z aplikace.",
                ecb_rates: "Měnové kurzy od Evropské centrální banky v reálném čase",
                excel_export: "Export do Excelu pro jednoduché a pohodlné podání daňového přiznání.",
                expense_tracking: "Evidence výdajů",
                password_links: "Faktury chráněné heslem přes unikátní odkaz.",
                qr_codes: "QR kód pro platbu ve faktuře pro české banky",
                website_link: "Odkaz na Váš web přímo ve faktuře",
                templates: "Šablony faktur – uložte si své údaje, platební metody a snadno je vkládejte nebo kopírujte",
            },
            roadmap: {
                feb1: "Automatické odesílání faktur a upomínky pro neuhrazené faktury",
                feb1_date: "Únor 2026",
                feb2: "Time tracking a fakturace na základě odpracovaného času",
                feb2_date: "Únor 2026",
                mar: "Synchronizace s bankami pro automatické rozpoznání plateb",
                mar_date: "Březen 2026",
                apr: "Sklad – systém evidence zboží propojený s fakturami",
                apr_date: "Duben 2026",
            },
            detailed: {
                feature1: "5 jazyků rozhraní i faktur: angličtina, čeština, slovenština, němčina a ruština.",
                feature2: "Přidejte jakékoli platební metody a odkazy přímo do faktury + QR platba.",
                feature3: "Libovolná měna.",
                feature4: "Odesílejte faktury přímo z Invoitio — ušetřete čas hledáním kontaktů :)",
                feature3a: "Bez omezení v plné verzi: neomezený počet faktur, klientů i dodavatelů.",
                feature3b: "Jednotný přehled zisku a výdajů ve zvolené měně.",
                feature3c: "Export pro účetní + samostatný přístup pro účetního.",
                feature3d: "Soulad s více jurisdikcemi.",
                feature5: "Pokročilá analytika příjmů: MRR, LTV, ARPU, toky příjmů a další — pro všechny měny.",
            },
        },
        pricing: {
            title: "Ceník",
            subtitle: "",
            limitedDiscount: "OMEZENÁ SLEVA 15%",
            monthly: "Měsíční předplatné",
            monthlyPrice: "220 Kč",
            monthlyOldPrice: "253 Kč",
            monthlyPeriod: " / měsíc",
            yearlyMainPrice: "133 Kč",
            yearlyOldMainPrice: "153 Kč",
            yearlyMainPeriod: "/ měsíc",
            yearlySubscriptionText: "s předplatným ",
            yearlySubPrice: "1600 Kč za rok",
            oneYear: "Roční plán",
            oneYearPrice: "1600 Kč",
            oneYearOldPrice: "1840 Kč za rok",
            oneYearPeriod: " / rok",
            oneYearButton: "Získat Invoitio nyní",
            trustedBy: "Důvěřuje 2500+ uživatelů",
            lifetime: "Doživotní přístup",
            lifetimePrice: "3960 Kč",
            lifetimeOldPrice: "4554 Kč",
            lifetimePeriod: " jednorázově",
            beneficial: "Nejvýhodnější nabídka",
            mostPopular: "Nejoblíbenější",
            hoursUntilPriceIncrease: "8 hodin do zvýšení ceny",
            features: {
                allFeatures: "Všechny funkce Invoitio",
                twoDevices: "2 zařízení: vy a účetní",
                support: "Podpora",
                forever: "Navždy — bez předplatného",
                allFuture: "Všechny současné i budoucí funkce",
                priority: "Prioritní podpora",
            },
            start: "Začít",
            buy: "Koupit",
        },
        faq: {
            title: "Časté dotazy",
            subtitle: "Časté dotazy",
            question0: "Lze převést faktury z jiného systému do Invoitio?",
            answer0: "Zdarma provedeme přenos faktur z Vašeho aktuálního zdaňovacího období do našeho systému (i během zkušebního období).",
            question1: "Máte partnerský program (affiliate program)?",
            answer1: "Ano, Invoitio nabízí partnerský program pro všechny uživatele. Získáte 30% celoživotní opakující se provizi z každého doporučení. V případě zájmu o účast v referenčním programu se [zaregistrujte] a v [nastavení] si zkopírujte referenční odkaz.",
            question2: "Mohu používat Invoitio zdarma?",
            answer2: "Ano! Invoitio můžete vyzkoušet zdarma na 30 dní. Poté jsou k dispozici měsíční, roční a doživotní tarify.",
            question5: "Jak Invoitio pomáhá s fakturami po splatnosti?",
            answer5: "(od února 2026) Systém automaticky hlídá termíny splatnosti a odesílá klientům připomínky k neuhrazeným fakturám. Můžete si také nastavit automatická upozornění.",
            question6: "Mohu exportovat faktury do účetních systémů?",
            answer6: "Ano, Invoitio umožňuje export faktur do formátů PDF, Excel (.xlsx). V 2026 bude zapojený export XML a ISDOC pro účetní systémy, například Pohoda nebo Money S3.",
            question7: "Kolik jazyků Invoitio podporuje?",
            answer7: "Invoitio podporuje 6 jazyků: angličtinu, češtinu, slovenštinu, němčinu, ruštinu a ukrajinštinu. Faktury i aplikaci můžete používat v kterémkoli z těchto jazyků.",
            answer7SignUp: "",
            answer7SignUpButton: "",
            answer7UserSettings: "",
            answer7UserSettingsButton: "",
            answer7Where: "",
            stillHaveQuestions: "Máte ještě otázky?",
        },
        cta: {
            title: "Začněte zdarma právě teď",
            subtitle: "Vytvářejte faktury za 10 sekund a získejte finanční přehledy okamžitě.",
            createAccount: "Vytvořit účet",
            viewDemo: "Zobrazit demo",
        },
        questions: {
            title: "Máte ještě dotazy? Rádi zodpovíme",
        },
        footer: {
            privacy: "Zásady ochrany osobních údajů",
            terms: "Podmínky",
            copyright: "© {year} Invoitio",
        },
        auth: {
            loginTitle: "Přihlášení do účtu",
            resetTitle: "Obnovení hesla",
            resetDescription: "Zadejte e-mail a pošleme Vám odkaz pro obnovení hesla.",
            email: "E-mail",
            password: "Heslo",
            signIn: "Přihlásit se",
            forgotPassword: "Zapomněli jste heslo?",
            sendResetLink: "Poslat odkaz",
            backToLogin: "Zpět na přihlášení",
            rememberMe: "Zapamatovat si mě",
            signUp: "Vytvořit účet",
            noAccount: "Nemáte účet?",
            alreadyHaveAccount: "Máte již účet?",
            passwordRequirements: "Heslo musí mít alespoň 8 znaků, obsahovat alespoň 1 malé a 1 velké písmeno, a 1 číslici",
            errors: {
                PASSWORD_TOO_SHORT: "Heslo musí mít alespoň 8 znaků, obsahovat alespoň 1 velké písmeno, 1 malé písmeno a 1 číslici",
                PASSWORD_TOO_LONG: "Heslo musí obsahovat maximálně 128 znaků včetně velkých a malých písmen a čísel",
                PASSWORD_MISSING_UPPERCASE: "Heslo musí mít alespoň 8 znaků, obsahovat alespoň 1 velké písmeno, 1 malé písmeno a 1 číslici",
                PASSWORD_MISSING_LOWERCASE: "Heslo musí mít alespoň 8 znaků, obsahovat alespoň 1 velké písmeno, 1 malé písmeno a 1 číslici",
                PASSWORD_MISSING_NUMBER: "Heslo musí mít alespoň 8 znaků, obsahovat alespoň 1 velké písmeno, 1 malé písmeno a 1 číslici",
                PASSWORD_INVALID_TYPE: "Heslo musí být platný řetězec",
                EMAIL_REQUIRED: "E-mail je povinný",
                PASSWORD_REQUIRED: "Heslo je povinné",
                EMAIL_INVALID: "Neplatný formát e-mailu",
                INVALID_CREDENTIALS: "Neplatný e-mail nebo heslo",
                USER_ALREADY_EXISTS: "Uživatel s tímto e-mailem již existsuje",
                AUTHENTICATION_REQUIRED: "Vyžaduje se ověření",
                TOKEN_INVALID: "Neplatný nebo vypršený token",
                TOKEN_EXPIRED: "Token vypršel",
                FAILED_TO_PROCESS: "Nepodařilo se zpracovat požadavek. Zkuste to prosím později.",
                FAILED_TO_RESET: "Nepodařilo se obnovit heslo. Zkuste to prosím později.",
                RESET_LINK_SENT: "Pokud účet s tímto e-mailem existuje, odeslali jsme pokyny k obnovení hesla.",
            },
        },
        registrationSuccess: {
            title: "Potvrďte prosím svůj e-mail",
            myLanguage: "Můj jazyk:",
            languages: {
                cs: "🇨🇿 Čeština",
                en: "🇬🇧 Angličtina",
                ru: "Ruština"
            },
            checkInboxBeforeEmail: "Zkontrolujte prosím svou schránku",
            checkInboxAfterEmail: "a klikněte na aktivační odkaz pro aktivaci účtu.",
            didntReceive: "Nedostal(a) jste e-mail?",
            checkSpam: "Zkontrolujte složku Spam a jiné",
            makeSureCorrect: "Ujistěre se, že e-mailová adresa je správná",
            waitMinutes: "Počkejte několik minut a zkuste to znovu",
            continueToDashboard: "Pokračovat na přehled"
        },
        verifyEmail: {
            verifying: "Ověřování e-mailu...",
            wait: "Počkejte prosím, než ověříme Vaši e-mailovou adresu.",
            verified: "E-mail byl ověřen!",
            success: "Váš e-mail byl úspěšně ověřen!",
            alreadyVerified: "Váš e-mail již byl ověřen. Nyní se můžete přihlásit.",
            failed: "Ověření selhalo",
            noToken: "Nebyl poskytnut žádný ověřovací token",
            goDashboard: "Přejít na přehled",
            goLogin: "Přihlásit se",
            signUpAgain: "Zkusit registraci znovu"
        },
        resetPassword: {
            title: "Obnovení hesla",
            newPassword: "Nové heslo",
            confirmPassword: "Potvrďte heslo",
            saveButton: "Uložit nové heslo",
            resetting: "Obnovování...",
            success: "Heslo bylo změněno!",
            redirecting: "Přesměrování na přehled...",
            invalidLink: "Neplatný odkaz",
            invalidLinkDescription: "Tento odkaz pro obnovení hesla je neplatný nebo vypršel.",
            backToLogin: "Přejít na přihlášení",
            passwordsDoNotMatch: "Hesla se neshodují",
        },
        testimonials: {
            title: "Důvěřují nám",
            subtitle: "Freelanceři, studia a malé firmy z 12 zemí",
            testimonial1: {
                name: "Maria, designerka",
                text: "Zkrátili čas na faktury z 20 minut denně na 5.",
            },
            testimonial2: {
                name: "Studio Nord",
                text: "Přesedlali z konkurenta: levnější a flexibilnější pole.",
            },
            testimonial3: {
                name: "Anton, dev shop",
                text: "Platby začaly přicházet o 30% rychleji.",
            },
        },
        testimonialsSection: {
            title: "Recenze zákazníků",
            testimonial2: {
                text: "Odesílání faktur přímo z aplikace šetří obrovské množství času. Možnost vystavovat faktury v jakékoli měně a v požadovaném jazyce je velkou výhodou. Jsem velmi spokojený jak s jednoduchostí, tak s rychlostí aplikace, a hlavně s její příznivou cenou oproti jiným aplikacím a absencí limitů na vytváření faktur. Díky, jste skvělí! :)",
                name: "Josef P.",
                role: "podnikatel v IT",
                img: "/josef.png",
            },
            testimonial1: {
                text: "Dříve jsem vedla účetnictví v Google tabulkách, a nebylo to úplně dobré dlouhodobě řešení. V Invoitio mám vše: faktury, výdaje, příjmy i důležité metriky pro startupy. Nejvíce oceňuji souhrnný přehled v jedné měně a export pro účetní — výrazně mi to zjednodušilo život a snížilo náklady na účetní služby při podání daňového přiznání.",
                name: "Kateřina ",
                role: "podnikatelka",
                img: "/katerina.png",
            },
        },
        team: {
            title: "Kdo to vytvořil?",
            members: {
                alice: {
                    name: "Alice",
                    role: "Zakladatelka",
                    bio: "{link}. Pracovala pro velká jména jako Canva a Wargaming. Miluje zjednodušovat složité věci.",
                    bioLinkText: "Senior software inženýrka s 6 lety praxe"
                },
                natalie: {
                    name: "Natálie",
                    role: "Marketing specialist",
                    bio: "Miluje dělat z malých věcí velké. Je také chemička (wow!)."
                },
                jana: {
                    name: "Jana A.",
                    role: "Inženýrka manuálního testování"
                },
                renata: {
                    name: "Renata G.",
                    role: "Front-end inženýrka a inženýrka manuálního testování"
                },
                simon: {
                    name: "Simon R.",
                    role: "Senior Back-end inženýr — konzultant"
                }
            }
        },
    },
    contact: {
        websiteBy: "website by kiki-mori studio",
    },
    notFound: {
        title: "Stránka nebyla nalezena",
        subtitle: "Hledaná stránka neexistuje nebo byla přesunuta.",
        cta: "Začít Invoitio zdarma",
    },
    terms: {
        title: "Obchodní podmínky",
        sections: [
            {
                title: "1. Informace o poskytovateli",
                paragraphs: [
                    "Platforma softwaru jako služby Invoitio („Služba“) je provozována následujícím poskytovatelem:",
                    "Poskytovatel: Alisa Zakhtarenko, OSVČ",
                    "IČO: 21512302",
                    "Sídlo: Praha – Vinohrady, Mánesova 1080/3, 12000",
                    "Stav DPH: Neplátce DPH",
                    "Kontakt: support [at] invoitio [dot] com",
                    "Tyto Podmínky upravují používání Služby poskytované Poskytovatelem.",
                ],
            },
            {
                title: "2. Popis Služby",
                paragraphs: [
                    "Služba je online SaaS platforma přístupná prostřednictvím uživatelského účtu.",
                    "Uživatelé získávají přístup k funkcionalitě Služby; na uživatele nejsou převáděna žádná vlastnická práva k základnímu softwaru, kódu nebo obsahu.",
                    "Služba je licencována, nikoli prodávána.",
                ],
            },
            {
                title: "3. Registrace a používání účtu",
                paragraphs: [
                    "Vytvořením účtu uživatelé souhlasí s poskytováním přesných a úplných informací.",
                    "Poskytovatel může omezit, pozastavit nebo ukončit přístup v případech, které zahrnují:",
                ],
                list: [
                    "zneužití nebo nevhodné chování,",
                    "bezpečnostní rizika,",
                    "porušení těchto Podmínek.",
                ],
                paragraphsAfterList: [
                    "Uživatelé souhlasí s tím, že budou Službu využívat zodpovědně a v souladu s platnými právními předpisy.",
                ],
            },
            {
                title: "4. Ceny, platby a fakturace",
                paragraphs: [
                    "Ceny jsou k dispozici na webových stránkách nebo v aplikaci.",
                    "Předplatné je účtováno na začátku každého fakturačního období.",
                    "Pokud platbu nelze zpracovat, může být přístup dočasně omezen až do vyřešení problému.",
                    "Faktury jsou vystavovány elektronicky.",
                ],
            },
            {
                title: "5. Předplatné a automatické obnovení",
                paragraphs: [
                    "Předplatné se automaticky obnovuje na konci každého fakturačního období.",
                    "Automatické obnovení lze kdykoli vypnout v rozhraní aplikace.",
                    "Pokud narazíte na jakékoli potíže s fakturací nebo zrušením, kontaktujte nás prosím na: support [at] invoitio [dot] com",
                ],
            },
            {
                title: "6. Reklamační řád a refundace",
                paragraphs: [
                    "Refundace se obecně nenabízejí.",
                    "Pokud však technické problémy vycházející ze Služby zabránily uživatelům ve zrušení předplatného nebo v přístupu k ovládacím prvkům fakturace, může Poskytovatel vystavit refundaci za postižené fakturační období.",
                    "Refundace mohou být také zvažovány individuálně ve výjimečných případech.",
                ],
                subsections: [
                    {
                        title: "6.1 Podmínky zrušení",
                        paragraphs: [
                            "Uživatelé mohou své předplatné kdykoli zrušit prostřednictvím rozhraní aplikace.",
                            "Měsíční předplatné: Uživatelé si ponechávají přístup až do konce aktuálního fakturačního období.",
                            "Všechny ostatní typy předplatného: Zrušení se řídí stejnými pravidly jako doživotní přístup; přístup zůstává platný pouze po dobu, kdy Služba nadále funguje.",
                            "Zrušení automaticky nevede k refundaci, pokud řádnému zrušení nezabránily technické problémy (jak je definováno výše).",
                        ],
                    },
                ],
            },
            {
                title: "7. Doživotní přístup (Lifetime Access)",
                paragraphs: [
                    "Pokud Služba nabízí možnost „doživotního přístupu“, rozumí se tím přístup po dobu provozní životnosti Služby, nikoli po dobu života uživatele.",
                    "Pokud bude Služba nebo podnikání ukončeno, stane se nerentabilním, právně nemožným provozovat nebo jinak zanikne, všechny formy přístupu — včetně doživotního přístupu — skončí.",
                    "Po uplynutí provozní životnosti Služby neplatí žádné refundace ani další závazky.",
                    "Měsíční předplatitelé si vždy ponechávají přístup až do konce svého fakturačního období, i když je plánováno ukončení Služby.",
                    "Všechny ostatní typy předplatného se řídí stejnými pravidly jako doživotní přístup.",
                ],
            },
            {
                title: "8. Duševní vlastnictví",
                paragraphs: [
                    "Veškerý software, zdrojový kód, design, branding, název Invoitio a veškerý související obsah jsou výhradním duševním vlastnictvím Poskytovatele.",
                    "Uživatelé získávají omezenou, nevýhradní, nepřenosnou licenci k používání Služby pouze pro zamýšlený účel.",
                    "Následující činnosti jsou přísně zakázány:",
                ],
                list: [
                    "kopírování nebo reprodukce Služby nebo jakékoli její části,",
                    "úprava, adaptace, překlad nebo vytváření odvozených děl,",
                    "zpětné inženýrství, dekompilace nebo pokus o extrakci zdrojového kódu,",
                    "zneužití názvu, loga, brandingu nebo prvků designu Invoitio ve vlastních produktech uživatele,",
                    "distribuce, přeprodej, sublicencování nebo poskytování přístupu ke Službě třetím stranám bez výslovného povolení Poskytovatele.",
                ],
                subsections: [
                    {
                        title: "Povolené použití",
                        paragraphs: [
                            "Uživatelé mohou odkazovat na Službu nebo ji zmiňovat (včetně názvu „Invoitio“) v médiích, recenzích, sociálních příspěvcích, článcích nebo informačních kontextech, pokud takové použití nenaznačuje vlastnictví Služby.",
                        ],
                    },
                ],
            },
            {
                title: "9. Omezení odpovědnosti",
                paragraphs: [
                    "Služba je poskytována „tak, jak je“, a je vynaloženo přiměřené úsilí k zajištění stability a dostupnosti.",
                    "Poskytovatel neodpovídá za:",
                ],
                list: [
                    "ztrátu dat,",
                    "přerušení služby nebo výpadky,",
                    "nepřímé, náhodné nebo následné škody.",
                ],
                paragraphsAfterList: [
                    "Celková odpovědnost Poskytovatele je omezena na částku zaplacenou uživatelem během posledních šesti (6) měsíců používání.",
                ],
            },
            {
                title: "10. Osobní údaje a soulad s GDPR",
                paragraphs: [
                    "Poskytovatel zpracovává osobní údaje v souladu s GDPR a českými právními předpisy o ochraně osobních údajů. Podrobnosti jsou popsány v Zásadách ochrany osobních údajů.",
                ],
            },
            {
                title: "11. Dostupnost Služby a aktualizace",
                paragraphs: [
                    "Mohou se vyskytnout dočasná období údržby nebo krátká přerušení.",
                    "Poskytovatel může Službu kdykoli aktualizovat, upravovat nebo vylepšovat za účelem zvýšení funkčnosti, bezpečnosti nebo výkonu.",
                ],
            },
            {
                title: "12. Ukončení a mazání dat",
                paragraphs: [
                    "Účty mohou být uzavřeny:",
                ],
                list: [
                    "na žádost uživatele,",
                    "z důvodu dlouhodobé neaktivity,",
                    "v případech zneužití nebo porušení Podmínek,",
                    "když to vyžaduje zákon.",
                ],
                paragraphsAfterList: [
                    "Po ukončení mohou být uživatelská data vymazána v souladu s právními a interními požadavky na uchovávání dat.",
                ],
            },
            {
                title: "13. Rozhodné právo",
                paragraphs: [
                    "Tyto Podmínky se řídí právními předpisy České republiky.",
                    "Případné spory budou řešeny věcně a místně příslušnými soudy v České republice.",
                ],
            },
        ],
    },
    privacy: {
        title: "Zásady ochrany osobních údajů",
        sections: [
            {
                title: "1. Úvod",
                paragraphs: [
                    "Tyto Zásady ochrany osobních údajů vysvětlují, jak Alisa Zakhtarenko, OSVČ („Poskytovatel“) zpracovává osobní údaje uživatelů platformy Invoitio („Služba“) v souladu s GDPR a příslušnými českými zákony o ochraně osobních údajů.",
                    "Používáním Služby potvrzujete, že jste si tyto Zásady přečetli a porozuměli jim.",
                ],
            },
            {
                title: "2. Kontaktní informace správce údajů",
                paragraphs: [
                    "Správce údajů:",
                    "Alisa Zakhtarenko, OSVČ",
                    "IČO: 21512302",
                    "Adresa: Praha – Vinohrady, Mánesova 1080/3, 12000",
                    "Email: support [at] invoitio [dot] com",
                ],
            },
            {
                title: "3. Osobní údaje, které zpracováváme",
                paragraphs: [
                    "Poskytovatel zpracovává pouze údaje nezbytné pro provoz Služby.",
                ],
                subsections: [
                    {
                        title: "3.1 Údaje poskytnuté uživatelem",
                        list: [
                            "e-mailová adresa",
                            "jméno (pokud je poskytnuto)",
                            "přihlašovací údaje",
                            "informace týkající se plateb (zpracovávané prostřednictvím platebních brán; Poskytovatel neobdrží čísla karet)",
                        ],
                    },
                    {
                        title: "3.2 Automaticky sbírané údaje",
                        list: [
                            "IP adresa",
                            "informace o zařízení a prohlížeči",
                            "protokoly o použití",
                            "diagnostická a technická data",
                        ],
                    },
                    {
                        title: "3.3 Fakturační údaje",
                        list: [
                            "ID transakcí",
                            "typ předplatného",
                            "platební historie",
                        ],
                    },
                ],
            },
            {
                title: "4. Účely zpracování",
                paragraphs: [
                    "Osobní údaje jsou zpracovávány pro:",
                ],
                list: [
                    "poskytování a provoz Služby",
                    "správu uživatelských účtů",
                    "zpracování plateb a vystavování faktur",
                    "zákaznickou podporu a komunikaci",
                    "zajištění bezpečnosti a prevenci zneužití",
                    "plnění zákonných povinností (daňové a účetní)",
                ],
            },
            {
                title: "5. Právní základy pro zpracování",
                paragraphs: [
                    "Zpracování je založeno na:",
                ],
                list: [
                    "plnění smlouvy (čl. 6 odst. 1 písm. b) GDPR) — poskytování Služby",
                    "oprávněném zájmu — zvyšování bezpečnosti a funkcionality",
                    "právní povinnosti — účetnictví, daňová evidence",
                    "souhlasu uživatele, pokud je vyžadován (např. volitelné soubory cookies)",
                ],
            },
            {
                title: "6. Sdílení osobních údajů",
                paragraphs: [
                    "Údaje mohou být sdíleny pouze s:",
                ],
                list: [
                    "zpracovateli plateb (např. Stripe, PayPal)",
                    "poskytovateli hostingu a infrastruktury",
                    "poskytovateli účetních nebo daňových služeb",
                    "orgány veřejné moci, pokud to vyžaduje zákon",
                ],
                paragraphsAfterList: [
                    "Poskytovatel neprodává osobní údaje třetím stranám.",
                ],
            },
            {
                title: "7. Uchovávání údajů",
                paragraphs: [
                    "Osobní údaje jsou uchovávány pouze po dobu nezbytně nutnou pro:",
                ],
                list: [
                    "poskytování Služby,",
                    "plnění zákonných povinností,",
                    "nebo dokud uživatel nepožádá o vymazání.",
                ],
                paragraphsAfterList: [
                    "Platební a účetní záznamy musí být uchovávány podle českých zákonů (obvykle 5–10 let).",
                ],
            },
            {
                title: "8. Práva uživatelů podle GDPR",
                paragraphs: [
                    "Uživatelé mají právo na:",
                ],
                list: [
                    "přístup ke svým osobním údajům",
                    "opravu",
                    "výmaz („právo být zapomenut“)",
                    "omezení zpracování",
                    "přenositelnost údajů",
                    "vznesení námitky proti zpracování",
                    "podání stížnosti u Úřadu pro ochranu osobních údajů (ÚOOÚ)",
                ],
            },
            {
                title: "9. Zabezpečení dat",
                paragraphs: [
                    "Poskytovatel používá vhodná technická a organizační opatření, včetně:",
                ],
                list: [
                    "šifrování",
                    "zabezpečeného přenosu dat",
                    "omezení přístupu",
                    "pravidelných aktualizací a monitorování bezpečnosti",
                ],
            },
            {
                title: "10. Mezinárodní přenosy dat",
                paragraphs: [
                    "Údaje mohou být zpracovávány v rámci EU nebo mimo ni.",
                    "Přenosy mimo EU se uskutečňují pouze v případě, že přijímající strana splňuje požadavky GDPR (např. SCC).",
                ],
            },
            {
                title: "11. Cookies",
                paragraphs: [
                    "Služba může používat nezbytné soubory cookies k zajištění autentizace a funkcionality.",
                    "Volitelné analytické nebo marketingové soubory cookies se používají pouze se souhlasem uživatele.",
                ],
            },
            {
                title: "12. Změny těchto Zásad",
                paragraphs: [
                    "Poskytovatel může tyto Zásady aktualizovat.",
                    "Případné změny budou zveřejněny na webových stránkách.",
                    "Pokračování v používání Služby představuje souhlas s aktualizovanými Zásadami.",
                ],
            },
            {
                title: "13. Kontakt pro dotazy k GDPR",
                paragraphs: [
                    "V případě jakýchkoli dotazů nebo požadavků týkajících se osobních údajů nás prosím kontaktujte na:",
                    "support [at] invoitio [dot] com",
                ],
            },
        ],
    },
    userSettings: {
        title: "Nastavení uživatele",
        general: {
            title: "Obecná nastavení",
            defaultLanguage: "Výchozí jazyk aplikace",
            defaultLanguageDescription: "Tento jazyk bude použit jako výchozí při přihlášení.",
            notificationEmail: "E-mailová adresa pro upozornění klientům na platby",
            notificationEmailHandle: "E-mailový handle",
            notificationEmailName: "Jméno odesílatele",
            notificationEmailPreview: "Takto bude vypadat Vaše adresa:",
            notificationEmailHandleErrorTaken: "Tato adresa je již obsazena jiným uživatelem",
            notificationEmailHandleErrorForbidden: "Tato adresa je rezervována a nelze ji použít",
        },
        changePassword: {
            title: "Změnit heslo",
            button: "Změnit heslo",
            resetLinkSent: "Pokyny k obnovení hesla byly zaslány na Váš e-mail.",
        },
        subscription: {
            title: "Předplatné",
        },
        subscriptionUi: {
            mostPopular: "NEJOBLÍBENĚJŠÍ",
            bestDeal: "NEJVÝHODNĚJŠÍ NABÍDKA",
            monthly: "MĚSÍČNÍ",
            yearly: "ROČNÍ",
            perMonth: "/ měsíc",
            perYear: "/ rok",
            subscribe: "Předplatit",
            cancel: "Zrušit předplatné",
            lifetime: "DOŽIVOTNÍ",
            planLabel: "PLÁN",
        },
        subscriptionDetails: {
            status: "Stav",
            renewsAt: "Obnoví se",
            accessUntil: "Přístup do",
            notSubscribed: "Bez předplatného",
            canceled: "Zrušeno",
            resubscribeTitle: "Obnovte si předplatné pro zachování přístupu",
            resubscribeSubtitle: "Vyberte si tarif níže a pokračujte po skončení aktuálního období.",
        },
        paymentMessage: {
            success: "Děkujeme za platbu! Vaše předplatné je nyní aktivní.",
            cancelled: "Platba byla zrušena. Pokud je to omyl, zkuste to prosím znovu.",
        },
        paymentSuccess: {
            title: "Platba proběhla úspěšně! 🎉",
            subtitle: "Jsme rádi, že můžeme pomoci Vašemu podniku  🙏🏻",
            button: "Pokračovat",
            team: "Tým Invoitio"
        },
        emailTransferNotice: "Pokud potřebujete změnit email a přenést předplatné na jiný účet, napište nám na support@invoitio.com",
        deleteAccountNotice: "Pokud chcete svůj účet smazat, napište nám z e-mailu, na který byl účet registrován, na adresu support@invoitio.com",
        trial: {
            title: "Vaše zkušební období",
            subtitle: "Zkušební období skončí za {days} {daysLabel}",
            subscribe: "Získejte předplatné se slevou 15 % do {date}",
            description: "Získejte neomezený přístup ke všem funkcím a profesionálním šablonám.",
            remainingDays: "Zbývající dny",
            barAction: "Zkušební období skončí za {days} {daysLabel}",
            barActionLead: "Předplaťte si nyní",
            thanks: "❤️ Děkujeme, že jste si nás vybrali",
        },
        trialExpired: {
            title: "Vaše zkušební období vypršelo!",
            description: "Předplaťte si Invoitio, abyste mohli nadále používat naši službu.",
            monthly: "Měsíční",
            yearly: "Roční",
            periodMonth: "/ měsíc",
            periodYear: "/ rok",
            lifetimeOffer: "Nechcete platit předplatné? Získejte doživotní přístup k Invoitio za {price}. Nabídka je omezená. Zbývá Vám {timer}.",
            lifetimeAccess: "Návratnost investice za 1,5 roku — získejte doživotní přístup za",
            lifetimeLimited: "Nabídka je časově omezená.",
            buyNow: "Získat doživotní přístup",
            subscribe: "Předplatit",
            thanks: "Děkujeme, že jste si nás vybrali",
            downloadPreviousInvoices: "Stáhnout dříve vytvořené faktury",
            downloadExpensesTable: "Stáhnout tabulku výdajů",
        },
        affiliate: {
            title: "Partnerský program",
            referredUsersTitle: "Přivedení uživatelé",
            description: "Získejte 30% provizi z plateb všech uživatelů, které přivedete. Doživotně.",
            yourReferralCode: "Váš referenční kód",
            copy: "Kopírovat",
            copied: "Zkopírováno",
            table: {
                email: "Email",
                signupDate: "Datum registrace",
                status: "Status",
                active: "Aktivní",
                trial: "Zkušební období",
                inactive: "Neaktivní",
            },
            bankInfo: {
                title: "Bankovní údaje pro výplaty",
                description: "Zadejte své bankovní údaje, na které si přejete dostávat provize z partnerského programu.",
                accountNumber: "Číslo účtu",
                iban: "IBAN",
                bic: "BIC",
                swift: "SWIFT",
                bankName: "Název banky",
                bankAddress: "Adresa banky",
                fullName: "Jméno a příjmení",
                save: "Uložit bankovní údaje",
                saved: "Bankovní údaje byly úspěšně uloženy",
                errorRequired: "Zadejte prosím číslo účtu nebo IBAN.",
            }
        },
    },
    // Blog
    blog: {
        title: "Blog",
        post1: {
            title: "Invoitio vs Fakturoid, iDoklad a FakturyWeb: Jaký fakturační systém vybrat v České republice?",
            intro: "Pokud hledáte fakturační službu v České republice, téměř vždy se objeví tři jména: Fakturoid, iDoklad a FakturyWeb. Jsou známé účetním, fungují dlouho a pokrývají základní úkoly. Invoitio se objevilo později — a bylo původně vytvořeno s jiným zaměřením: ne jen 'vystavit fakturu', ale zjednodušit život freelancerům, malým firmám a účetním zároveň. Níže najdete upřímné srovnání bez reklamních sloganů.",
            comparisonTitle: "Stručné srovnání",
            table: {
                feature: "Funkce",
                languages: "Jazyky rozhraní",
                currencies: "Měny",
                rates: "Měnové kurzy (ECB)",
                analytics: "Analytika (MRR, ARPU, LTV)",
                multiProfit: "Multiměnový zisk",
                accountingAccess: "Přístup pro účetního",
                export: "Export dokumentů",
                lifetime: "Doživotní přístup",
                speed: "Rychlost vytvoření faktury",
                yes: "Ano",
                no: "Ne",
                limited: "Omezeně",
                partial: "Částečně",
                average: "Průměrně",
                faster: "Pomalejší",
                seconds: "≈ 10 sekund"
            },
            focusTitle: "Invoitio — když je důležitá nejen faktura, ale i pochopení byznysu",
            focusText: "Invoitio nebylo vytvořeno jako 'další faktura', ale jako pracovní nástroj pro ty, kteří pracují s klienty z různých zemí, dostávají příjmy v různých měnách a chtějí rozumět tomu, kolik a na čem vydělávají, a ne jen ukládat faktury. Služba je stejně pohodlná pro freelancery, malé firmy i účetní, kteří spravují klienty.",
            featuresTitle: "Co je v Invoitio opravdu pohodlné",
            feature1Title: "Jazyky bez kompromisů",
            feature1Text: "Rozhraní i samotné faktury jsou k dispozici v pěti jazycích: angličtina, čeština, slovenština, němčina a ruština. To je u českých služeb vzácnost a velké plus, pokud Vaši klienti nejsou jen z ČR.",
            feature2Title: "Jednoduché a silné UI",
            feature2Text: "Rozhraní je navrženo tak, aby nepřekáželo v práci. Minimum obrazovek, logický tok, nic přebytečného. V rychlosti a pohodlí Invoitio poráží většinu konkurentů — faktura je reálně vytvořena během sekund.",
            feature3Title: "Libovolné měny + správný přepočet",
            feature3Text: "Příjem lze počítat v jedné základní měně, i když klienti platí v různých. Kurzy jsou automaticky stahovány z Evropské centrální banky (ECB). Z porovnávaných služeb to mají pouze Invoitio a iDoklad.",
            feature4Title: "Analytika, ne jen seznam faktur",
            feature4Text: "MRR, ARPU, LTV, příjmy podle klientů a měn — bez Excelu a ručních výpočtů.",
            feature5Title: "Samostatný přístup pro účetního",
            feature5Text: "Bez sdílení přihlašovacího jména a hesla. Přístup je zahrnut v ceně — to je důležité, pokud s účetním spolupracujete neustále.",
            feature6Title: "Platba bez pastí",
            feature6Text: "Můžete si vybrat předplatné, nebo si můžete koupit doživotní přístup jednou platbou a zapomenout na účty za službu.",
            fakturoidTitle: "Fakturoid — spolehlivý, ale konzervativní",
            fakturoidText: "Fakturoid je skvělý pro lokální byznys v České republice. Je stabilní, jasný a účetním známý. Ale: téměř žádná analytika, slabá práce s měnami, příliš se nehodí pro freelancery a mezinárodní práci. Dobrá volba, pokud máte vše v CZK a bez plánů na růst.",
            idokladTitle: "iDoklad — především pro účetnictví",
            idokladText: "iDoklad je pohodlný, když je účetní hlavním uživatelem. Dobře zvládá účetnictví a daně. Nevýhody: rozhraní je přetížené, analytika je omezená, není nejrychlejší pro každodenní práci freelancera.",
            fakturywebTitle: "FakturyWeb — nejjednodušší možnost",
            fakturywebText: "Vhodné, pokud potřebujete jen vystavit fakturu a nic jiného. Ale: téměř žádná automatizace, žádná analytika, slabé možnosti růstu.",
            conclusionTitle: "Pro koho je Invoitio nejvhodnější",
            conclusionText: "Invoitio je dobrou volbou, pokud jste: freelancer se zahraničními klienty, majitel malé firmy, účetní spravující několik klientů, pracujete v různých měnách, chcete jednoduché rozhraní a kontrolu nad příjmy, a nechcete být věčně na předplatném."
        },
        post2: {
            title: "Jak vystavit fakturu jako OSVČ?",
            intro: "Začínáte podnikat jako OSVČ a přemýšlíte, jak správně vystavit svou první fakturu? Ať už jste plátcem DPH nebo ne, existují pravidla, která musíte dodržet. V tomto průvodci Vás provedeme vším od povinných údajů až po moment, kdy se případně stanete plátcem DPH.",
            ctaTitle: "Vzor faktury neplátce DPH",
            ctaText: "Fakturu si můžete rovnou vygenerovat online – v bezplatném generátoru faktur a to zvládnete do minuty po registraci.",
            q1Title: "Kdy musím vystavit fakturu jako OSVČ?",
            q1Text: "Neplátce DPH (OSVČ či firma s obratem do 2 mil. Kč) nemá zákonem stanovenu přesnou lhůtu pro vystavení faktury, na rozdíl od plátců, ale doporučuje se tak učinit co nejdříve po dodání zboží nebo služby.",
            q2Title: "Kdy se stáváte plátcem DPH?",
            q2Text: "Plátcem DPH se stanete v těchto případech:",
            q2List: [
                "od 1. ledna následujícího roku, pokud váš obrat za předchozí kalendářní rok přesáhne 2 000 000 Kč,",
                "následující den po překročení obratu 2 536 500 Kč v průběhu kalendářního roku,",
                "pokud zdědíte ekonomickou činnost po osobě, která byla plátcem DPH,",
                "nebo pokud převezmete podnik či majetek v rámci privatizace, fúze nebo rozdělení společnosti."
            ],
            q2Note: "Pokud s podnikáním teprve začínáte, pravděpodobně nejste plátcem DPH. V takovém případě pro Vás platí jednodušší pravidla.",
            section1Title: "Faktury pro neplátce DPH",
            section1Text: "Požadavky na fakturu vycházejí z občanského zákoníku, konkrétně ze zákona č. 89/2012 Sb.",
            section1MandatoryTitle: "Povinné údaje na faktuře:",
            section1MandatoryList: [
                "jméno a příjmení (u OSVČ) nebo název společnosti,",
                "sídlo firmy nebo OSVČ,",
                "údaj o zápisu v registru (obchodní rejstřík včetně oddílu a vložky, případně živnostenský rejstřík),",
                "IČ (identifikační číslo osoby)."
            ],
            section1MandatoryNote: "Z pohledu zákona nejsou vyžadovány žádné další povinné údaje.",
            section1OptionalTitle: "Nepovinné, ale běžně uváděné údaje:",
            section1OptionalList: [
                "informace o odběrateli (obvykle ve stejném rozsahu jako u dodavatele – jméno / název, adresa, IČ),",
                "číselné a slovní označení dokladu (např. FV-2025-001),",
                "popis dodaného zboží nebo poskytnuté služby,",
                "částka k úhradě (celková nebo rozepsaná podle jednotek a množství),",
                "datum vystavení faktury."
            ],
            q3Title: "A co datum splatnosti?",
            q3Text: "Zákon stanovuje základní lhůtu splatnosti na 30 dní (je současně i maximální lhůtou), nicméně je možné se s klientem dohodnout i na jiné splatnosti.",
            edgeCaseTitle: "Faktura neplátce DPH při vedení účetnictví",
            edgeCaseText: "Účetnictví jsou povinny vést všechny právnické osoby, a to bez ohledu na výši jejich příjmů. Pokud máte povinnost vést účetnictví (například jako právnická osoba), nebo jste se pro něj rozhodli dobrovolně (např. OSVČ místo daňové evidence), řídí se náležitosti faktury zákonem č. 563/1991 Sb., o účetnictví.",
            edgeCaseMandatoryTitle: "Faktura neplátce DPH v účetnictví obsahuje stejné základní údaje jako u daňové evidence, navíc však musí zahrnovat:",
            edgeCaseMandatoryList: [
                "popis zboží nebo služby,",
                "fakturovanou částku (celkem nebo rozepsanou dle jednotek a množství),",
                "datum vystavení dokladu,",
                "údaj o zápisu do veřejného rejstříku (včetně oddílu a vložky)."
            ],
            finalCtaTitle: "Vyzkoušejte Invoitio zdarma",
            finalCtaText: "Generujte faktury během několika sekund a mějte přehled o tom, kdy se blížíte k hranici pro vznik povinnosti stát se plátcem DPH - bez ručního počítání a bez stresu."
        }
    },

    // Time Tracking
    timeTracking: {
        title: "Sledování času",
        newProject: "Nový projekt",
        projectName: "Název projektu",
        createProject: "Vytvořit projekt",
        noProjects: "Zatím žádné projekty. Vytvořte svůj první projekt a začněte sledovat čas.",
        addService: "Přidat úkol nebo službu",
        serviceName: "Název služby",
        hourlyRate: "Hodinová sazba",
        dailyRate: "Denní sazba",
        fixedPrice: "Pevná cena",
        rate: "Částka",
        totalTime: "Celkový čas",
        totalAmount: "Celková částka",
        billed: "Fakturovano",
        notBilled: "Nefakturovano",
        generateInvoice: "Vystavit fakturu",
        selectItems: "Vyberte položky k fakturaci",
        timerRunning: "Časovač běží",
        timerPaused: "Časovač pozastaven",
        units: {
            hourly: "/ hod",
            daily: "/ den",
            fixed: "fix"
        },
        deleteModal: {
            titleProject: "Smazat projekt",
            messageProject: "Opravdu chcete smazat tento projekt? Všechny přidružené úkoly a záznamy času budou trvale odstraněny.",
            titleTask: "Smazat úkol",
            messageTask: "Opravdu chcete smazat tento úkol? Tuto akci nelze vrátit zpět.",
            confirm: "Smazat",
            cancel: "Zrušit"
        }
    },
};
